module.exports = __webpack_public_path__ + "images/teal-background.74eb045c336199cb7e4691140b57ffff.png";